/* Redirect Brand Domains to their collection page */

const domain = window.location.href
const collectionPre = 'https://mycitygear.com/collections/'
const pagePre = 'https://mycitygear.com/pages/'

console.log('Redirect check for redirecting Brand Domains to their collection page (custom-js.js)', domain)

if ( domain.search('southieapparel.myshopify.com') === -1 ) {
  if ( domain.search('usashamrock.com') !== -1 ) {
    window.location.href = pagePre + 'usa-shamrock'
  } else if ( domain.search('southieapparel.com') !== -1 ) {
    window.location.href = pagePre + 'southie-apparel'
  } else if ( domain.search('dorchesterapparel.com') !== -1 ) {
    window.location.href = pagePre + 'dorchester-apparel'
  } else if ( domain.search('bostonhoodie.com') !== -1 ) {
    window.location.href = pagePre + 'boston-apparel'
  } else if ( domain.search('//charlestown') !== -1 || domain.search('www.charlestown') !== -1 ) {
    window.location.href = pagePre + 'charlestown-apparel'
  } else if ( domain.search('just-wave.com') !== -1 ) {
    window.location.href = pagePre + 'just-wave'
  }
}